import AssigneeEntityContent from '@/components/entity-detail/components/Entity/AssigneeEntity';
import type { TDetailServiceParams } from '@/components/entity-detail/types/EntityType.types';
import { userService } from '@/services/rest';
import type { ApiResponse } from '@/types/common/api.type';
import { t } from '@/utils/lang';
import { Entity } from '../entity';

export class AssigneeEntity extends Entity {
    public getTitleTemplate(response?: string): string {
        if (!response) {
            return t('Nhân viên');
        }

        return `${t('Nhân viên')}: ${this.getTitle(response)}`;
    }

    public getEntityComponent(): any {
        return AssigneeEntityContent;
    }

    public getIncludeProperties() {
        return {};
    }

    public getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<any>> {
        return userService().detail(params.id, {
            ...this.getIncludeProperties(),
            ...params,
        });
    }

    public getFieldName(): string {
        return 'fullname';
    }

    public getDetailUrl(id: string): string {
        return this.routeManager.getRouteMap()[this.getRouteDetail()].path(id);
    }

    public showDetailButton(): boolean {
        return true;
    }

    public getRouteDetail(): string {
        return this.routeManager.STAFF_DETAIL;
    }
}
